/** Tell the server about a crash (it groups repeats and shows them to the owner) and heal the one crash we can fix alone: a stale app after a deploy. */
let sent = 0;
export function reportCrash(message: string) {
  if (sent++ > 5) return; // never flood
  void fetch("/api/incidents/report", {
    method: "POST",
    credentials: "same-origin",
    headers: { "content-type": "application/json", "x-qn-client": "web" },
    body: JSON.stringify({ message: message.slice(0, 400), route: location.pathname }),
  }).catch(() => undefined);
}

const isStaleChunk = (m: string) =>
  /dynamically imported module|importing a module script failed|loading chunk|error loading dynamically/i.test(
    m,
  );

/** After a deploy an old tab asks for a file that no longer exists: reload once (guarded) instead of showing an error. */
export function installSelfHealing() {
  const heal = (msg: string) => {
    if (!isStaleChunk(msg)) return false;
    try {
      if (sessionStorage.getItem("qn-healed") === String(Math.floor(Date.now() / 60_000)))
        return false;
      sessionStorage.setItem("qn-healed", String(Math.floor(Date.now() / 60_000)));
    } catch {
      /* private mode: still try once */
    }
    reportCrash(`stale-client: ${msg}`);
    location.reload();
    return true;
  };
  addEventListener("vite:preloadError", (e: Event) => {
    e.preventDefault();
    heal("importing a module script failed");
  });
  addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => {
    const m = e.reason instanceof Error ? e.reason.message : String(e.reason ?? "");
    if (!heal(m) && m) reportCrash(`unhandledrejection: ${m}`);
  });
  addEventListener("error", (e: ErrorEvent) => {
    if (!heal(e.message ?? "") && e.message) reportCrash(`error: ${e.message}`);
  });
}
